import script from "./ProfitCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfitCalculator.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__